<script setup>
import { events } from '@/utils/events.js'

defineProps({
  errorCode: Number
})

const tryAgain = () => {
  events.value.triggerTakePicture = true
}
</script>

<template>
  <div class="flex flex-col items-center justify-start gap-5 px-4 h-full">
    <img
      alt=""
      class="mt-1 w-full max-w-28"
      src="../assets/icons/alert-octagon.svg"
    />
    <div class="flex flex-col gap-2 text-center">
      <h1 class="text-2xl font-bold break-words [hyphens:auto]">
        {{ $t('backend_error.unexpected_error') }}
      </h1>
      <p class="text-xl break-words">
        {{ $t('backend_error.try_again_later') }}
      </p>
      <p v-if="errorCode >= 500" class="text-lg text-[#999999] font-normal">
        ({{ $t('backend_error.error_code', { code: errorCode }) }})
      </p>
    </div>
    <button
      class="rounded bg-[var(--primary)] p-2.5 text-lg font-bold text-white"
      @click="tryAgain"
    >
      {{ $t('backend_error.try_again') }}
    </button>
  </div>
</template>
